"use client";

import { CardTitle, cn, editorContentVariants, Field } from "@atlas/core";
import { useTranslation } from "@atlas/sdk";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import { useMemo } from "react";

interface ICatalogOverviewProps {
  overview: string;
  typeId?: string;
}

export function CatalogOverview({ overview }: ICatalogOverviewProps) {
  const { t } = useTranslation();
  const safeHtml = useMemo(
    () =>
      DOMPurify.sanitize(overview || "", {
        // TipTap Color / paste can emit inline colors that stay dark in dark mode.
        FORBID_ATTR: ["style"],
      }),
    [overview],
  );

  return (
    <div className="w-full min-w-0 space-y-2 text-left">
      <CardTitle>
        {t("hub.create_catalog.overview", { defaultValue: "Overview" })}
      </CardTitle>
      <Field orientation="vertical" className="gap-2">
        <div
          className={cn(
            editorContentVariants(),
            "rich-text-editor-content min-h-0 w-full min-w-0 px-0 py-0 leading-relaxed",
          )}>
          {parse(safeHtml)}
        </div>
      </Field>
    </div>
  );
}
